<template>
  <div class="login">
    <div class="center_box">
      <div class="login_tit">
        人社局养老金管理系统
      </div>
      <div class="login_min">
        <vue-form :state="formstate" id="loginForm">
          <validate tag="div" class="p_rel">
            <input class="user_name" id="user_name" type="text" name="username"  placeholder="手机号" v-model="userName"
            required pattern="^[1][0-9]{10}$">
            <field-messages name="username" show="$dirty || $touched || $submitted">
              <div slot="required" class="errorMessage">手机号不能为空</div>
              <div slot="pattern" class="errorMessage">请填写正确的手机号</div>
            </field-messages>
          </validate>
          <validate tag="div" class="p_rel mt30">
            <input id="password" class="pass_word" type="password" name="credentials"  placeholder="密码" v-model="passWord"
            required pattern="^\d{6}$">
            <field-messages name="credentials" show="$dirty || $touched || $submitted">
              <div slot="required" class="errorMessage">密码不能为空</div>
              <div slot="pattern" class="errorMessage">请输入6位数字密码</div>
            </field-messages>
          </validate>
          <div>
            <button id="login" :class="{can_login:canSubmit == true}" type="" :disabled="!canSubmit" @click.prevent="longinIn">登录</button>
          </div>
        </vue-form>
      </div>
      <div class="login_info clearfix">
        <span class="fr no_login"><router-link to="/forget_password">忘记密码？</router-link></span>
      </div>
    </div>
    <toastTips :content="toastContent" :is-show="toast"></toastTips>
  </div>
</template>
<script>
  import axiox from 'axios'
  import qs from 'qs'
  import toastTips from '../components/layer/toastTips.vue'
  export default {
    name:'login',
    components:{
      toastTips
    },
    data () {
      return {
        userName:'',
        passWord:'',
        canSubmit:false,
        errorMsg:'',
        toastContent:'',
        toast:false,
        formstate:{},
      }
    },
    methods:{
      checkIsLogin:function(){
        var phoneReg = /^[1][0-9]{10}$/,
            passwordReg = /^\d{6}$/;
        if (phoneReg.test(this.userName) && passwordReg.test(this.passWord)){
            this.canSubmit = true;
            this.errorMsg='';
        }else{
          if(this.userName && !phoneReg.test(this.userName)){
            this.errorMsg='请输入正确的手机号';
            return;
          }else if(this.passWord && !passwordReg.test(this.passWord)){
            this.errorMsg='请输入正确的密码';
            return;
          }
          this.canSubmit = false;
        }
      },
      longinIn:function(){
        var that=this;
        axiox.post('/login/login',qs.stringify(
          {
            mobile:this.userName,
            password:this.passWord
          }
        )).then((response)=>{
          console.log(response);
          if(response.data.code==22000){
            if(response.data.result.first_land_flag==0){
              window.location.href='/#/improve_info';
            }else{
              window.location.href='/#/list/0';
            }
            localStorage.setItem('role',response.data.result.role);
          }else{
            that.toast=true;
            that.toastContent=response.data.message;
            setTimeout(function(){
              that.toast=false;
              that.toastContent='';
            },3000)
          }
        })
      }
    },
    watch:{
      'formstate.$invalid':function(){
        if(!this.formstate.$invalid){
          this.canSubmit=true;
        }else{
          this.canSubmit=false;
        }

      }
    }
  }
</script>
<style lang="less" scoped>
  .p_rel{
    position: relative !important;
  }
  .mt30{
    margin-top: 30px!important;
  }
</style>



// WEBPACK FOOTER //
// src/view/login.vue